import React from "react";

import type { IOldButtonProps } from "./types";
import { OldButton as OldButtonComponent } from "./components/OldButton";

export const OldButton = (props: IOldButtonProps) => (
  <OldButtonComponent {...props} />
);
